import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationComponent } from './component/registration/registration.component';
import { OtpComponent } from './component/otp/otp.component';
import { PaymentComponent } from './component/payment/payment.component';
import { PaymentstatusComponent } from './component/paymentstatus/paymentstatus.component';
import { Router, RouterModule, Routes } from '@angular/router';
import { CourseslandingComponent } from './component/courseslanding/courseslanding.component';
import { SharedModule } from '@app-shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@app-core/core.module';
import { NgOtpInputModule } from 'ng-otp-input';

const routes :Routes = [
  {
    path:'',
    component:CourseslandingComponent,
    children:[
      {
        path: '',
        redirectTo: 'registration',
        pathMatch: 'full'
      },
      {
        path:'registration',
        component:RegistrationComponent
    },
    {
      path:'otp',
      component:OtpComponent
    },
    {
      path:'payment',
      component:PaymentComponent
    },
    {
      path:'paymentstatus',
      component:PaymentstatusComponent
    }] 
  }
]

@NgModule({
  declarations: [
  
    RegistrationComponent,
    OtpComponent,
    PaymentComponent,
    PaymentstatusComponent,
    CourseslandingComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule
  ],
  
})
export class CoursesModule { }
